import React from 'react';

import {
    GalleryNext,
    GalleryNextSlides,
    GalleryNextThumbnailsUS,
    GalleryNextBadges,
    GalleryNextExpandBtn,
    useGalleryNextContext,
    ImageWithPlaceholder,
} from '@hpi-sox/hpstellar-core';

import { getGTMClickAttributes } from '../../../../metrics/metrics-helpers';

import './gallery-enhanced.less';

const ExpandBtn = ({ onExpand, indexOffset }) => {
    const { selectedIndex } = useGalleryNextContext();
    const offsetSelectedIndex = selectedIndex === 0 ? 0 : selectedIndex + indexOffset;

    return (
        <GalleryNextExpandBtn
            className="pdp-gallery-expand-btn"
            onClick={() => {
                onExpand(offsetSelectedIndex);
            }}
        />
    );
};

export default function GalleryEnhanced({ images, badges, onExpand, hasVideo }) {
    const galleryImages = images.reduce(
        (acc, img) => {
            if (img.type === '360' || img.type === 'video') {
                return acc;
            }
            acc.thumbnails.push({
                ImageWithPlaceholderProps: {
                    src: img.url,
                    alt: img.alt,
                },
            });
            acc.slides.push(img);
            return acc;
        },
        { thumbnails: [], slides: [] },
    );

    const indexOffset = hasVideo ? 2 : 1;

    const threeDButtonProps = {
        onClick: () => onExpand(indexOffset),
        ...getGTMClickAttributes('linkClick', 'gallery', '3d'),
    };

    const videoButtonProps = hasVideo && {
        onClick: () => onExpand(1),
    };

    return (
        <GalleryNext>
            <div className="gallery-enhanced">
                <GalleryNextThumbnailsUS
                    thumbnails={galleryImages.thumbnails}
                    moreButtonProps={{
                        onClick: () => onExpand(0),
                    }}
                    threeDButtonProps={threeDButtonProps}
                    videoButtonProps={videoButtonProps}
                />

                <GalleryNextSlides
                    outerChildren={<ExpandBtn onExpand={onExpand} indexOffset={indexOffset} />}
                    CarouselProps={{
                        dots: true,
                        carouselIndicatorProps: {
                            showOnlyOnMobile: true,
                            hideArrows: true,
                            showSlidesCounter: false,
                            threeDButtonProps,
                            videoButtonProps,
                        },
                    }}
                >
                    {galleryImages.slides.map(({ url, alt }, i) => (
                        <ImageWithPlaceholder src={url} key={i} decoding="async" loading="lazy" alt={alt} />
                    ))}
                </GalleryNextSlides>
                <div className="gallery-enhanced-badges-container">
                    <GalleryNextBadges className="gallery-enhanced-badges" badges={badges} />
                </div>
            </div>
        </GalleryNext>
    );
}
